module.exports = __webpack_public_path__ + "img/paragraphEle.0dda8e6c.svg";